import body from "../../index.module.scss"
import classes from "./header.module.scss"
import {ReactComponent as Arrow} from "../Assets/Img/Src/Svg/arrow_left.svg"
import {ReactComponent as ArrowWhite} from "../Assets/Img/Src/Svg/arrow_left-white.svg"
import { useEffect,  useState } from "react"

const Header = () => {

  const [fixed, setFixed] = useState(false);
  const [button, showButton] = useState(false);
  const fixedHeader = () => {
    const top = window.scrollY;

    return top > 90 ? setFixed(true) : setFixed(false);
  }
  const scrollButon = () => {
    const top = window.scrollY;

    return top > window.innerHeight ? showButton(true) : showButton(false);
  }
  useEffect(() => {
    window.addEventListener('scroll', fixedHeader);
    window.addEventListener('scroll', scrollButon);
  });

  return (
    <header className={classes.Header}>
      <div className={fixed ? classes.Fixed : ""}>
        <div className={body.container}>
          <div className={classes.Wrap}>
            <a href="/"  className={classes.Return + " " + (button ?  classes.ReturnMobile : "")}>
             
            <span>
            <ArrowWhite className={classes.Icon}/>
              <Arrow className={classes.Icon}/>Вернуться назад</span>
          </a>
            <nav className={classes.Nav}>
              <ul className={classes.List}>
                <li className={classes.Item}>
                  <a href="#Analys" data-anchor className={classes.Link}>Анализ</a>
                </li>
                <li className={classes.Item}>
                  <a href="#Works" data-anchor className={classes.Link}>Работы</a>
                </li>
                <li className={classes.Item}>
                  <a href="#Result" data-anchor className={classes.Link}>Результаты</a>
                </li>
                <li className={classes.Item}>
                  <a href="#Nuances" data-anchor className={classes.Link}>Нюансы</a>
                </li>
                <li className={classes.Item}>
                  <a href="#Technology" data-anchor className={classes.Link}>Технологии</a>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </div>
    </header>
  )

}



export default Header